import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {ProfileViewComponent} from "./profile-view.component";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ng2-bootstrap';
import {SlackApi} from "../../components/slack-api/slack-api.component";

@NgModule({
    declarations: [ProfileViewComponent],
    imports     : [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        ModalModule
    ],
    providers: [
        SlackApi
    ]
})

export class ProfileModule {}


// WEBPACK FOOTER //
// ./src/app/views/profile/profile.module.ts